import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useToast } from 'components/hooks/useToast';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

export interface ReviewCycleRow {
  reviewCycle: ReviewCycle;
  cohorts: Cohort[];
  currentStageName: string;
}

export interface ReviewCycle {
  id: number;
  name: string;
  description: string;
  pendingCount: any;
  lastEnabledSection: string | null;
  currentStage: string | null;
  startDate: string | null;
  endDate: string | null;
  hasCustomSettings: boolean;
  updatedOn: string;
}

export interface Cohort {
  id: number;
  name: string;
}

export const REVIEW_CYCLE_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
};

export const REVIEW_CYCLE_STATUS_LABELS = {
  [REVIEW_CYCLE_STATUSES.IN_PROGRESS]: 'In Progress',
  [REVIEW_CYCLE_STATUSES.DRAFT]: 'Draft',
  [REVIEW_CYCLE_STATUSES.PUBLISHED]: 'Published',
};

export const REVIEW_CYCLE_STATUS_COLORS = {
  [REVIEW_CYCLE_STATUSES.IN_PROGRESS]: 'yellow',
  [REVIEW_CYCLE_STATUSES.DRAFT]: 'black',
  [REVIEW_CYCLE_STATUSES.PUBLISHED]: 'green',
};

const getReviewCycles = ({ isArchive }: { isArchive: boolean }): Promise<{ entity: ReviewCycleRow[] }> =>
  // return Promise.resolve({
  //   entity: [
  //     {
  //       reviewCycle: 'Cycle 1',
  //       reviewPeriod: '2022',
  //       views: ['View 1', 'View 2'],
  //       customized: true,
  //       createdBy: {
  //         name: 'John Doe',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'IN_PROGRESS'
  //     },
  //     {
  //       reviewCycle: 'Cycle 2',
  //       reviewPeriod: '2023',
  //       views: ['View 3', 'View 4'],
  //       customized: false,
  //       createdBy: {
  //         name: 'Jane Smith',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'DRAFT'
  //     },
  //     {
  //       reviewCycle: 'Cycle 3',
  //       reviewPeriod: '2024',
  //       views: ['View 5', 'View 6'],
  //       customized: true,
  //       createdBy: {
  //         name: 'Michael Johnson',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'DRAFT'
  //     },
  //     {
  //       reviewCycle: 'Cycle 4',
  //       reviewPeriod: '2025',
  //       views: ['View 7', 'View 8'],
  //       customized: false,
  //       createdBy: {
  //         name: 'Emily Davis',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'IN_PROGRESS'
  //     },
  //     {
  //       reviewCycle: 'Cycle 5',
  //       reviewPeriod: '2026',
  //       views: ['View 9', 'View 10'],
  //       customized: true,
  //       createdBy: {
  //         name: 'Robert Wilson',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'PUBLISHED'
  //     },
  //     {
  //       reviewCycle: 'Cycle 6',
  //       reviewPeriod: '2027',
  //       views: ['View 11', 'View 12'],
  //       customized: false,
  //       createdBy: {
  //         name: 'Olivia Johnson',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'DRAFT'
  //     },
  //     {
  //       reviewCycle: 'Cycle 7',
  //       reviewPeriod: '2028',
  //       views: ['View 13', 'View 14'],
  //       customized: true,
  //       createdBy: {
  //         name: 'William Thompson',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'IN_PROGRESS'
  //     },
  //     {
  //       reviewCycle: 'Cycle 8',
  //       reviewPeriod: '2029',
  //       views: ['View 15', 'View 16'],
  //       customized: false,
  //       createdBy: {
  //         name: 'Sophia Anderson',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'PUBLISHED'
  //     },
  //     {
  //       reviewCycle: 'Cycle 9',
  //       reviewPeriod: '2030',
  //       views: ['View 17', 'View 18'],
  //       customized: true,
  //       createdBy: {
  //         name: 'James Clark',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'DRAFT'
  //     },
  //     {
  //       reviewCycle: 'Cycle 10',
  //       reviewPeriod: '2031',
  //       views: ['View 19', 'View 20'],
  //       customized: false,
  //       createdBy: {
  //         name: 'Ava Turner',
  //         imgUrl: 'https://i1.sndcdn.com/artworks-AV3yT135aFYucjX4-O771hA-t500x500.jpg'
  //       },
  //       lastUpdated: new Date(),
  //       status: 'IN_PROGRESS'
  //     }
  //   ]
  // });

  sendRequest({
    url: endpoints.reviews.reviewCycleCreation.reviewsList,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      is_archive: isArchive,
    },
    body: undefined,
  });
export const useGetReviewCycles = ({ isArchive }: { isArchive: boolean }) =>
  useQuery([REACT_QUERY_KEYS.reviewCreation.reviewCycles, isArchive], () =>
    getReviewCycles({ isArchive }).then((res) => res.entity)
  );

const cloneReviewCycle = (reviewCycleId: string): Promise<void> =>
  sendRequest({
    url: endpoints.reviews.reviewCycleCreation.reviewsClone,
    method: 'POST',
    credentials: 'include',
    queryParams: {
      reviewCycleId,
    },
    body: undefined,
  });

export const useCloneReviewCycle = () => {
  const toast = useToast();

  return useMutation<void, void, { reviewCycleId: string }>(
    ({ reviewCycleId }: { reviewCycleId: string }) => cloneReviewCycle(reviewCycleId),
    {
      onSuccess: () => {
        toast({
          position: 'bottom-left',
          title: 'Review Cycle successfully cloned',
        });
      },
      onError: () => {
        toast({
          position: 'bottom-left',
          title: 'Error occurred while cloning this review cycle',
          status: 'error',
        });
      },
    }
  );
};

const archiveUnArchiveReviewCycle = (reviewCycleId: string, isArchive: boolean): Promise<void> =>
  sendRequest({
    url: endpoints.reviews.reviewCycleCreation.reviewsArchive,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      review_cycle_id: reviewCycleId,
      is_archive: isArchive,
    },
    body: undefined,
  });

export const useArchiveUnArchiveReviewCycleMutation = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    void,
    {
      message?: string;
    },
    { reviewCycleId: string; isArchive: boolean }
  >(({ reviewCycleId, isArchive }) => archiveUnArchiveReviewCycle(reviewCycleId, isArchive), {
    onSuccess: (_, { isArchive }) => {
      toast({
        position: 'bottom-left',
        title: `Review Cycle successfully ${isArchive ? 'archived' : 'un-archived'}`,
      });
      queryClient.invalidateQueries([REACT_QUERY_KEYS.reviewCreation.reviewCycles]);
    },
    onError: (error, { isArchive }) => {
      toast({
        position: 'bottom-left',
        title: error.message ?? `Error occurred while ${isArchive ? 'archiving' : 'un-archiving'} this review cycle`,
        status: 'error',
      });
    },
  });
};
